var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiDialogContentText from '@material-ui/core/DialogContentText';
/**
 * Kareo wrapped component of the Material-UI DialogContentText. The prop API has been limited to props defined in DialogContentTextProps.
 *
 * Material-UI DialogContentText: [Docs](https://v4.mui.com/components/dialogs/), [API](https://v4.mui.com/api/dialog-content-text/)
 *
 * @storybook: [Dialog](http://design.kareoprod.ent/design-system/?path=/story/components-feedback-dialog)
 */
var DialogContentText = React.forwardRef(function (props, ref) {
    return React.createElement(MuiDialogContentText, __assign({}, props, { ref: ref }));
});
DialogContentText.displayName = 'KareoDialogContentText';
export default DialogContentText;
